// extracted by mini-css-extract-plugin
export var option = "_3v-1";
export var optionActive = "_3v-2";
export var pill = "_3v-0";